export const setSelectedPlace = ({ place }) => state => {
  //eslint-ignore

  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      selectedPlace: {
        ...place,
      },
    },
  };
};
